export default __webpack_public_path__ + "a8d6692d20f0ea95e2b85b90e3758874.webp";